import { QtyItem } from "../ui/QtyItem"
import { AloAddress } from "./AloAddress"
import { AloBase, getDefaultAloBase } from "./AloBase"
import { AloForfait } from "./AloForfait"


export interface IAloPanier  {    
    items:Array<QtyItem<AloForfait>>    
    clientSecret:string
    address:AloAddress
}

export class AloPanier  {   
    public items:Array<QtyItem<AloForfait>> 
    public clientSecret:string
    public address:AloAddress

    constructor({items,clientSecret,address}:IAloPanier = {} as IAloPanier) {    
        this.items = items ?? []
        this.clientSecret = clientSecret ?? "" 
        this.address = address
    }              
    
    public get nbItems() {   
        return this.items.reduce((total,item)=>total+item.qty,0)
    }

    get prixTotal() {
        return this.items.reduce((total,item)=>total+((item.item.fftTarif??0) * item.qty) ,0)
    }

    get tvas():Array<{pourcentage:number,montant:number}> {        
        const dicTva = this.items.reduce((tvas,item) => {            
            tvas[item.item.tva!] = (tvas[item.item.tva!] ?? 0) + ( (item.item.tva!/100.0) * ((item.item.fftTarif??0) * item.qty) / (100.0+(item.item.tva!/100.0)) )
            return tvas
        },{}  as {[tva:number]:number})                  
        return Object.keys(dicTva).map(k => {return {pourcentage:Number.parseInt(k),montant:dicTva[Number.parseFloat(k)]}})
    }

}
